var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaylistPause(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 39.8,
    height: 39.8,
    viewBox: "0 0 39.8 39.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2493",
    "data-name": "Grupo 2493",
    transform: "translate(-375 -332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_429",
    "data-name": "Grupo 429",
    transform: "translate(375 332)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_428",
    "data-name": "Grupo 428"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_843",
    "data-name": "Caminho 843",
    d: "M19.9,0A19.9,19.9,0,1,0,39.8,19.9,19.922,19.922,0,0,0,19.9,0Zm0,38.142A18.242,18.242,0,1,1,38.142,19.9,18.262,18.262,0,0,1,19.9,38.142Z",
    fill: "#dbb200"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "pause",
    transform: "translate(218 -331.549)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pause-icon",
    transform: "translate(170 675)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_375",
    "data-name": "Grupo 375",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_374",
    "data-name": "Grupo 374"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_725",
    "data-name": "Caminho 725",
    d: "M47.254,0H43.726a1.06,1.06,0,0,0-1.059,1.059v14.82a1.06,1.06,0,0,0,1.059,1.059h3.529a1.06,1.06,0,0,0,1.059-1.059V1.059A1.06,1.06,0,0,0,47.254,0Zm.353,15.879a.353.353,0,0,1-.353.353H43.726a.353.353,0,0,1-.353-.353V1.059a.353.353,0,0,1,.353-.353h3.529a.353.353,0,0,1,.353.353v14.82Z",
    transform: "translate(-42.667)",
    fill: "#dbb200",
    stroke: "#dbb200",
    strokeWidth: 1
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_377",
    "data-name": "Grupo 377",
    transform: "translate(8.469)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_376",
    "data-name": "Grupo 376"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_726",
    "data-name": "Caminho 726",
    d: "M303.254,0h-3.529a1.06,1.06,0,0,0-1.059,1.059v14.82a1.06,1.06,0,0,0,1.059,1.059h3.529a1.06,1.06,0,0,0,1.059-1.059V1.059A1.06,1.06,0,0,0,303.254,0Zm.353,15.879a.353.353,0,0,1-.353.353h-3.529a.353.353,0,0,1-.353-.353V1.059a.353.353,0,0,1,.353-.353h3.529a.353.353,0,0,1,.353.353Z",
    transform: "translate(-298.667)",
    fill: "#dbb200",
    stroke: "#dbb200",
    strokeWidth: 1
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaylistPause);
export default __webpack_public_path__ + "static/media/playlist-pause.8e30ca49c9b4a5832fb86a1313ab20a8.svg";
export { ForwardRef as ReactComponent };